// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "bundle.chunk." + chunkId + ".js?" + {"vendors-node_modules_rive-app_canvas-lite_rive_js-node_modules_use-deep-compare_dist-web_index_js":"e87dd19fd0f5e88d4a05","reactapp_Components_Shared_RiveComponent_RiveCanvas_jsx":"3adaa3d953da8b26652b"}[chunkId] + "";
};